export default __webpack_public_path__ + "static/media/web.fce690dc.config";